import React, { useState, useRef } from "react";
import {
    Typography,
    ClickAwayListener,
    Popper,
    Paper,
    MenuList,
    MenuItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles(() => ({
    formControl: {
        position: "relative",
        marginTop: "2.1rem",
        backgroundColor: "#1C1E20",
        borderRadius: "4px",
        width: "8rem",
        cursor: "pointer",
        padding: "0.1rem 0.6rem 0.1rem 0.8rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    iconWrapper: {
        color: "#ffffff",
        transition: "transform 0.3s ease",
    },
    popper: {
        zIndex: 3,
    },
    paper: {
        backgroundColor: "#1C1E20",
        borderRadius: "6px",
        boxShadow: "none",
        padding: 0,
    },
    menuContainer: {
        padding: 0,
        width: "7.07rem",
    },
    menuItem: {
        color: "#ffffff",
        width: "100%",
        height: "2rem",
        padding: "0.6rem 0.6rem 0.6rem 0.8rem",
        "&.Mui-selected": {
            backgroundColor: "#E8A33D",
        },
        "&.Mui-selected:hover": {
            backgroundColor: "#E8A33D",
        },
        "&:first-child.Mui-selected": {
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
        },
        "&:last-child.Mui-selected": {
            borderBottomLeftRadius: "6px",
            borderBottomRightRadius: "6px",
        },
        "&:first-child:hover": {
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
        },
        "&:last-child:hover": {
            borderBottomLeftRadius: "6px",
            borderBottomRightRadius: "6px",
        },
    },
    selected: {
        color: "#ffffff",
    },
}));

export default function SortMatchesSelect({ setSortOption, defaultSortOption, sortValues, }) {
    const classes = useStyles();
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(defaultSortOption);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleSelect = (option) => {
        setValue(option);
        setOpen(false);
        setSortOption(option.toLowerCase());
    };

    return (
        <>
            <ClickAwayListener onClickAway={handleClose}>
                <div ref={anchorRef} className={classes.formControl} onClick={handleToggle}>
                    <Typography className={classes.selected}>{value}</Typography>
                    <ExpandMoreIcon className={classes.iconWrapper} style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}/>
                </div>
            </ClickAwayListener>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                className={classes.popper}
                placement="bottom-start"
                disablePortal
            >
                <Paper className={classes.paper}>
                    <MenuList className={classes.menuContainer}>
                        {sortValues.map((option) => (
                            <MenuItem
                                key={option}
                                selected={option === value}
                                onClick={() => handleSelect(option)}
                                className={classes.menuItem}
                            >
                                <Typography>{option}</Typography>
                            </MenuItem>
                        ))}
                    </MenuList>
                </Paper>
            </Popper>
        </>
    );
}